import Calculation from './Calculation';

export default Calculation;